import {DashboardContent} from "./DashboardContent";

export function DashboardDNBContent() {
    return (
        <DashboardContent
            dataEndpoint="/dashboard/affordableHousing/data"
            titleSuffix="Dashboard DNB"
            showConsultationCharts={false}
            filterDescription="Přehled zahrnuje pouze živé projekty obcí a příspěvkových organizací s typem financování 2.10 – Dostupné bydlení nebo 2.10 – NRB nebo DNB2 nebo DNB3 (bez fiktivních obcí)."
        />
    );
}
